<template>
  <li :class="clName">
    <div :class="[card, { 'noprice': property.no_price }]" :style="{ backgroundImage: card === 'card trans' && !home ? 'url(' + property.images[0].url + ')' : home ? 'url(' + property.images[0].file.normal.url + ')' : ''}" :id="property.id" @click.stop.prevent="goToProp(property.id, property.link, property.suggested)">
      <div class="imgs">
        <Gallery v-if="card !== 'card trans' && card !== 'card seo'"
                 :images="property.images"
                 :card="true"
                 @hideBanners="hideBanners"
                 @showBanners="showBanners"
        />
        <img :class="{ 'trans': card === 'card trans' }" class="img" v-if="card === 'card trans' || card === 'card seo'" :alt="property.images[0].caption" :src="property.images[0].url" />
        <div class="card_booking" v-if="property.laterooms">Partner deal</div>
        <div class="pet" v-show="property.pets !== 'false' && property.pets !== 'No'" title="This property allows pets">
          <div class="maxpet" v-show="isNumber(property.pets)">
            {{ property.pets }}
          </div>
          <svg>
            <use xlink:href="#icon-pet"></use>
          </svg>
        </div>
        <div v-if="property.discount_percentage && property.discount_percentage > 0" :class="{ 'hide': hideBans }" class="bans top">
          <h3 class="sban" :class="{'visible': property.discount_percentage > 0 }">{{ property.discount_percentage | percent }}% off</h3>
        </div>
        <div :class="{ 'hide': hideBans }" class="bans btm">
          <h3 class="ban cap" v-if="property.unit_type">{{ property.unit_type.available }} of {{ property.unit_type.total }} available</h3>
        </div>
      </div>
      <div class="detail">
        <div class="head">
          <div class="titles">
            <h4 class="region"> {{ property.town.name || '&nbsp' }}</h4>
            <h3 class="name" v-if="!property.unit_type" :title="property.name"> {{ property.name }}</h3>
            <h3 class="name" v-if="property.unit_type"> {{ property.unit_type.name }}</h3>
            <p class="ref" v-if="card !== 'card trans' && property.original_id">Ref: {{ property.original_id }}</p>
            <p class="ref" v-else-if="card !== 'card trans'">Ref: S{{ property.id }}</p>
            <h3 class="revs" v-if="property.total_reviews > 0">
              <strong>{{ property.total_reviews }}</strong>
               {{ property.total_reviews > 1 ? 'Customer Reviews' : 'Customer Review'}}
            </h3>
          </div>
          <div class="side" v-if="card !== 'card trans'">
            <div class="beds">
              <svg viewBox="0 0 512 512">
                <path d="m474 241c-14 0-24 6-24 15l0 28c-13-25-32-43-57-43l-226 0c-5 0-8 3-8 8l0 48c0-13-6-26-16-36-20-18-50-16-69 3-17 19-17 47 0 66-4 0-9 2-12 5l0-204c0-11-11-20-25-20-13 0-24 9-24 20l0 349c0 11 11 20 24 20 14 0 25-9 25-20l0-53 388 0 0 57c0 9 10 16 24 16 15 0 25-7 25-16l0-228c0-9-10-15-25-15z m-429 239c0 1-2 4-8 4-5 0-8-3-8-4l0-349c0-1 3-4 8-4 6 0 8 3 8 4z m130-223l218 0c31 0 54 45 57 89l-275 0z m-16 40l0 39c-4-3-8-5-13-6 8-9 13-20 13-33z m-49-32c18 0 33 15 33 32 0 18-15 33-33 33-18 0-32-15-32-33 0-17 14-32 32-32z m340 146l-388 0 0-49c4 0 7-4 7-8 0-4 4-8 8-8l65 0c5 0 8 4 8 8 0 5 4 8 8 8l292 0z m33 71c-6 2-11 2-17 0l0-224c6-2 11-2 17 0z m-331-290l29-35c2-3 3-6 1-9-1-3-4-4-7-4l-49 0 0 16 32 0-30 35c-2 3-2 6-1 9 2 3 4 4 8 4l48 0 0-16z m88-40l47-60c1-3 2-6 0-9-1-2-4-4-7-4l-65 0 0 16 49 0-47 60c-2 2-2 6-1 8 2 3 4 5 8 5l64 0 0-16-48 0z m105-41l63-84c2-2 2-6 1-8-2-3-4-5-7-5l-73 0 0 16 56 0-63 84c-2 3-2 6-1 9 2 3 5 4 8 4l81 0 0-16z"/>
              </svg>
              <p class="sleep-info">{{ property.beds }}</p>
            </div>
            <div class="sleeps">
              <svg viewBox="0 0 512 512">
                <path d="m437 229c-16-8-46-8-48-8-3 0-7 3-7 7 0 4 4 7 7 7 8 0 31 1 42 6 3 2 7 1 9-3 2-3 0-7-3-9z m34 98l-28-8c-2 0-2-1-2-3l0-9c2-2 4-3 6-5 10-10 16-23 16-37l0-13 3-6c3-6 4-13 4-20l0-35c0-4-3-7-7-7l-66 0c-24 0-44 20-44 44l0 0c0 6 1 11 4 17l3 7 0 11c0 17 9 33 22 43l0 10c0 2 0 3-5 4l-14 4-40-14c0-2-1-4-2-6l-13-13 0-23c1-1 3-2 4-3 16-16 25-37 25-59l0-18c5-11 8-22 8-34l0-74c0-4-3-7-7-7l-104 0c-36 0-66 30-66 66l0 15c0 12 3 23 8 34l0 15c0 26 11 49 29 65l0 23-13 13c-1 2-2 4-1 6l-43 15c-3 1-6 3-8 5l-7-4c20-8 26-21 26-21 1-2 1-4 0-6-5-10-5-29-6-43 0-5 0-10 0-14-3-33-28-58-59-58-31 0-56 25-59 58 0 4 0 9 0 14-1 14-1 33-6 43-1 2-1 4 0 6 0 0 6 13 26 21l-18 9c-10 5-16 15-16 26l0 52c0 3 3 6 7 6 3 0 6-3 7-6 0 0 0 0 0 0l0-52c-1-5 3-11 8-13l23-12 8 8c11 11 29 11 40 0l8-8 8 4c-4 6-6 13-6 19l0 54c0 3 3 6 7 6 4 0 7-3 7-6l0-54c0-9 6-18 15-21l45-16 18 28c3 3 7 6 11 6 0 0 1 0 1 0 4 0 8-1 10-4l12-11 0 72c0 3 3 6 7 6 3 0 7-3 7-6 0 0 0 0 0 0l0-72 11 11c3 3 6 4 10 4 0 0 1 0 1 0 5 0 9-3 11-6l19-28 44 16c9 3 15 12 15 21l0 54c0 3 3 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-54c0-9-4-18-10-25l2 0c1-1 4-2 6-3l18 18 0 64c0 3 3 6 7 6 3 0 6-3 6-6 0 0 0 0 0 0l0-64 18-18c1 1 2 1 3 2l28 8c7 2 12 8 12 14l0 58c0 3 3 6 6 6 4 0 7-3 7-6 0 0 0 0 0 0l0-58c0-13-8-24-21-28z m-406-12c-13-4-19-11-22-14 2-5 3-11 4-17 4 9 10 17 18 23z m40 19c-6 5-16 5-21 0l-7-6c1-2 2-5 2-7l0-7c10 3 20 3 30 0l0 7c0 2 1 5 2 7z m-11-32c-21 0-37-17-37-37 0-4-3-7-7-7-1 0-1 0-1 0 0-1 0-1 0-2 0-5 0-9 0-13 1-12 6-24 14-32 8-9 19-13 31-13 12 0 23 4 31 13 8 8 13 20 14 32 0 4 0 8 0 13 0 1 1 1 1 1-8-11-20-20-35-25-13-4-25-4-26-4-2 0-3 1-5 2l-12 13c-3 3-3 7 0 10 3 3 7 3 10 0l10-11c9 1 38 4 49 29-3 18-18 31-37 31z m29 13l0-8c8-6 15-13 18-23 1 6 2 12 4 17-2 3-9 10-22 14z m67-112l0-17c0-1-1-2-1-3-4-9-7-19-7-29l0-15c0-29 24-52 52-52l97 0 0 67c0 10-2 20-7 29 0 1 0 2 0 3l0 20c0 18-8 36-22 49-1 1-3 3-5 4 0 0 0 0 0 0-13 10-29 15-45 13-35-2-62-32-62-69z m39 139c-1 0-1 0-1 0 0 0 0 0 0 0l-22-32 7-7 33 22z m28-27l-38-25 0-13c10 5 21 9 32 9 2 0 4 0 6 0 13 0 25-3 37-9l0 13z m28 27c0 0 0 0 0 0 0 0 0 0 0 0l-18-17 33-22 7 7z m127-6l-16-15c0-2 0-3 0-5l0-2c5 1 9 2 14 2 1 0 1 0 2 0 5 0 10-1 15-2l0 2c0 2 0 3 0 4z m26-44c-8 7-17 10-28 10-20 0-36-18-36-39l0-13c0-1 0-2-1-3l-4-9c-1-3-2-6-2-10l0 0c0-17 13-30 30-30l59 0 0 28c0 5-1 10-3 14l-3 7c-1 1-1 2-1 3l0 15c0 10-4 20-11 27z m18 69c-4 0-7 3-7 7l0 45c0 3 3 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-45c0-4-3-7-7-7z m-399 9c-4 0-7 4-7 7l0 36c0 3 3 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-36c0-3-3-7-7-7z m256-214c-26-26-81-21-103-17-7 1-12 7-12 14l0 16c0 4 3 7 7 7 4 0 7-3 7-7 0 0 0 0 0 0l0-16c0 0 0-1 0-1 9-1 27-3 45-2 22 2 37 7 46 16 3 3 7 3 10 0 3-2 3-7 0-10 0 0 0 0 0 0z m-138 220c-3 0-7 3-7 7l0 30c0 3 4 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-30c0-4-3-7-7-7z m163 0c-4 0-7 3-7 7l0 30c0 3 3 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-30c0-4-3-7-7-7z"/>
              </svg>
              <p class="sleep-info">{{ property.sleeps }}</p>
            </div>
          </div>
          <div class="desc" v-if="card === 'card seo'">
            <p class="text">{{ property.description | userFriendly }}</p>
            <ul class="amen">
              <li v-for="feat in feats" v-if="property[feat.title] === 'Yes'" :title="feat.desc">
                <svg><use :xlink:href="feat.icon"></use></svg>
              </li>
              <li v-for="tag in tags" v-if="typeof property.lmc_tags !== 'undefined' && property.lmc_tags[tag.title]" :title="tag.desc">
                <svg><use :xlink:href="tag.icon"></use></svg>
              </li>
            </ul>
          </div>
        </div>
        <div class="foot ctr-ver">
          <div v-if="card !== 'card trans'" class="card_price">
            <div class="price-line" v-show="property.discount_price > 0">
              <div class="price-con">
                <p class="total">{{property.discount_price | money }}</p>
                <span class="was" v-show="property.original_price !== property.discount_price">{{ property.original_price | money }}</span>
              </div>
            </div>
          </div>
          <p v-if="card === 'card seo'" class="new" @click.stop="newSearch">Start a new search</p>
          <h3 v-if="card === 'card trans'" class="sleeps">Sleeps {{ property.sleeps }}</h3>
          <a :title="property.name"  class="view" :href="property.link">View</a>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import Gallery from '../shared/gallery.vue'

export default {
    data: function () {
        return {
            hideBans: false,
            feats: [
                { title: 'open_fire', desc: 'Cottages with a real fire', icon: "#icon-fire" },
                { title: 'swimming_pool', desc: 'Swimming Pool available onsite', icon: "#icon-pool" },
                { title: 'hot_tub', desc: 'Use of Hot Tub onsite', icon: "#icon-hottub" },
                { title: 'parking', desc: 'Parking available', icon: "#icon-parking" },
                { title: 'pets', desc: 'Well behaved dogs and pets are welcome', icon: "#icon-pet" },
                { title: 'cots', desc: 'Cottages that welcome families and children', icon: "#icon-children" },
                { title: 'wifi', desc: 'Cottages with wifi or an internet connection available onsite', icon: "#icon-wifi" },
            ],
            tags: [
                { title: 'smoking', desc: 'Smoking allowed', icon: "#icon-smoke", owner: true },
                { title: 'easy access', desc: 'Easy Access for those with limited mobility', icon: "#icon-eaccess", owner: true },
                { title: 'wheelchair access' , desc: 'Full Wheelchair Access is provided at this property', icon: "#icon-wheelchair", owner: true },
                { title: 'fishing', desc: 'Fishing within a short distance', icon: "#icon-fishing", owner: true },
                { title: 'golf', desc: 'There is a golf course nearby', icon: "#icon-golf", owner: true },
                { title: 'games room', desc: 'Games Room available onsite', icon: "#icon-games", owner: true },
                { title: 'function room', desc: 'Function or Meeting Room at this property', icon: "#icon-function", owner: true },
                { title: 'eco friendly', desc: 'Eco Friendly Property or Green Tourism Rated', icon: "#icon-eco", owner: true },
                { title: 'sauna', desc: 'Use of Sauna onsite', icon: "#icon-sauna", owner: true },
                { title: 'car charger', desc: 'Electric car charger point', icon: "#icon-car", owner: true },
                { title: 'boats or moorings' , desc: 'Waterside Property', icon: "#icon-boats", owner: true },
                { title: 'national park', desc: 'Holiday cottages in or near a National Park', icon: "#icon-park", owner: true },
                { title: 'glamping', desc: 'Glamping or camping available at this location', icon: "#icon-car", owner: true },
                { title: 'unusual', desc: 'Unusual or Different Property. Stay in something different', icon: "#icon-lighthouse", owner: true },
                { title: 'short breaks', desc: 'Short Breaks Available', icon: "#icon-short", owner: true },
                { title: 'tennis', desc: 'Cottages with a tennis court', icon: "#icon-tennis", owner: true },
                { title: 'riding', desc: 'Horseriding is available nearby', icon: "#icon-horse", owner: true },
                { title: 'romantic', desc: 'Romantic cottage for Two', icon: "#icon-heart", owner: true },
                { title: 'luxury', desc: 'Luxury cottage', icon: "#icon-luxury", owner: true },
                { title: 'pub nearby', desc: 'Pub within a mile and a half', icon: "#icon-pub", owner: true },
                { title: 'beach', desc: 'Cottage near a beach', icon: "#icon-coastal", owner: true }
            ]
        }
    },
    props: {
        property: {
            type: Object,
            required: true
        },
        clName: String,
        card: String,
        date: String,
        nights: Number,
        home: Boolean
    },
    filters: {
        percent(val) {
            return parseInt(val * 100);
        },
        userFriendly: function (value) {
            let doc = new DOMParser().parseFromString(value, 'text/html');
            return doc.body.textContent.replace(/<[^>]*>?/gm, ' ') || "";
        },
        money(val) {
            if (typeof val !== "undefined" && val !== "" && val !== null) {
                if (window.Intl) {
                    let dec = parseFloat(val) % 1 === 0 ? 0 : 2;
                    return new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'GBP',
                        maximumFractionDigitsDigits: dec,
                        minimumFractionDigits: dec
                    }).format(val);
                } else {
                    return "£" + val;
                }
            }
        }
    },
    components: {
        Gallery
    },
    methods: {
        goToProp: function (id, link) {
            let date = this.$props.date,
                nights = this.$props.nights;
            let newDate = st.reverseDate(date);
            let hasDate = this.hasVal(date),
                hasNights = this.hasVal(nights);

            let url = !hasDate && !hasNights ? link : link + "?"
                + (hasDate ? "check_in_on=" + newDate : "")
                + (hasDate && hasNights ? "&" : "")
                + (hasNights ? "nights=" + nights : "");

            this.$emit('track', "prop_click", id);

            if (document.body.classList.contains("isIE")) {
                window.location.href = url;
            } else {
                window.open(url, "_blank");
            }
        },
        hasVal(val) {
            return val !== "" && typeof val !== "undefined";
        },
        hideBanners() {
            this.hideBans = true;
        },
        showBanners() {
            this.hideBans = false;
        },
        formatPrice(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        isNumber(value) {
            return typeof value === 'number';
        },
        isScrollFinished() {
            const isFinished = setInterval(() => {
                if (window.scrollY === 0) {
                    document.getElementById("date").click();
                    clearInterval(isFinished);
                }
            }, 25);
        },
        newSearch: function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            this.isScrollFinished();
        }
    }
}
</script>


<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
$padding: 2rem;

.card_booking {
  width: 7.5rem;
  position: absolute;
  top: 1.25rem;
  background: #411585;
  z-index: 9;
  font-size: .875rem;
  color: #FFF;
  padding: .4rem 1rem .4rem .5rem;
  margin: 0 0 .625rem 0;
  font-weight: 600;
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
}

.count, .ban, .sban {
  opacity: 1;
  transition: opacity 0.25s ease-in-out;
}

.hide {
  .caption, .count, .viewbtn, .ban, .sban {
    opacity: 0;
  }
}

.ref {
  color: $col_bgrey;
  text-transform: uppercase;
  display: inline;
  margin: 0 .625rem 0 0;
  font-size: .563rem;
  font-weight: 600;
}

.card {
  height: auto;
  box-shadow: 0 .125rem .25rem $col_oplightblack;
  cursor: pointer;
  position: relative;
  background: $col_white;
  background-repeat: no-repeat;
  background-size: cover;

  &.trans {
    max-height: 28.625rem;
  }

  &.seo {
    .titles {
      width: 79%;
    }
  }

  &:hover,
  &:focus-within {
    box-shadow: 0 .125rem 1.25rem 0 #D3EFE4;
  }

  &.white {
    .detail {
      background: $col_white;
    }
  }

  &.trans {
    background-repeat: no-repeat;
    background-size: cover;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.35);
      z-index: 1;
    }

    .sleeps, .beds, .revs, .region, .name, .view {
      color: $col_white;
      text-shadow: 0 .125rem .25rem $col_halfopacity;
    }

    .imgs,
    .detail {
      position: relative;
      z-index: 2;
    }
  }
}

.amen {
  margin: 1.25rem 0 0 0;

  li {
    display: inline-block;
    width: 1.25rem;
    padding: 0 0.313rem 0.313rem 0;

    svg {
      fill: $col_primary;
      width: 1.25rem;
      height: 1.25rem;
    }
  }
}

.imgs {
  position: relative;
  overflow: hidden;
  min-height: 14.313rem;

  &.st-fade-out {
    .fav,
    .pet,
    .bans{
      opacity: 0;
    }
  }
}

.maxpet {
  height: 1.25rem;
  text-align: center;
  width: 1.25rem;
  font-size: .688rem;
  line-height: 1.25rem;
  background: $col_white;
  position: absolute;
  top: 1.5rem;
  border-radius: 100%;
  left: 50%;
  margin-left: -.625rem;
  font-weight: 700;
  box-shadow: 0 .125rem .125rem $col_oplightblack;
}

.mem.visible,
.itm,
.bans {
  display: flex;
}

.mem.visible,
.itm {
  flex-direction: row;
  align-items: center;
}

.sban,
.ban,
.sug {
  line-height: 1.875rem;
  font-size: .75rem;
  padding: 0 1.25rem 0 .625rem;
  color: $col_white;
  height: 1.875rem;
  z-index: 9;
  font-weight: 700;

  &.cap {
    text-transform: uppercase;
  }
}

.sban,
.mem,
.sug {
  margin-bottom: .625rem;
}

.mem {
  font-size: .75rem;
  color: $col_white;
  border-radius: 0 1.25rem 1.25rem 0;
  font-weight: 700;
  padding: .625rem 1.25rem .625rem .625rem;
  min-width: 8.75rem;
  box-shadow: 0 .125rem .125rem $col_oplightblack;
  display: none;
  margin-bottom: .625rem;
  left: 0;
  transition: background-color 0.2s ease-in-out;
  background: $col_purple;
  z-index: 9;

  &:not(.mem.wht):hover {
    background-color: lighten($col_purple, 10%);
  }

  &.wht {
    background: $col_white;
    color: $col_purple;

    span.mem {
      color: $col_purple;
    }
  }

  span {
    line-height: 110%;
    color: $col_white;
    font-size: .75rem;
  }

  u {
    font-weight: 400;
    display: block;
  }
}

.bans,
.ban {
  left: 0;
}

.bans {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  z-index: 1;

  &.top {
    top: 1.25rem;
  }

  &.btm {
    bottom: 1.25rem;
  }

  .noprice &.btm {
    display: none;
  }
}

.sug,
.ban {
  background: $col_dblue;
}

.ban {
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
}

.sban {
  background: $col_dred;
  text-transform: uppercase;
  padding: 0 1.25rem 0 .625rem;
}

.sban,
.sug {
  border-radius: 0 .938rem .938rem 0;
  display: none;
}

.ban {
  width: auto;
  border-radius: 0 .938rem .938rem 0;
}

.sban {
  &.visible {
    display: block;
  }
}

.suggest .sug {
  display: block;
}

.fav,
.pet,
.balls,
.bans,
.ban {
  position: absolute;
}

.fav,
.pet,
.bans {
  opacity: 1;
  transition: opacity 2s ease;
}

.fav,
.pet{
  top: 1.25rem;
}

.src {
  background: $col_bgrey;
  z-index: 9;
  font-size: .875rem;
}

.src,
.text {
  font-size: .875rem;
  clear: both;
  line-height: 1.25;
}

.new {
  font-weight: 700;
  text-transform: uppercase;
  color: $col_primary;
  align-self: flex-end;

  &:hover {
    text-decoration: underline;
  }
}

.desc {
  clear: both;
  padding: 1.25rem 0;
  min-height: 10rem;
  position: relative;

  &:before,
  &:after {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: .0625rem;
    background: $col_grey;
  }

  &:before {
    top: .625rem;
  }

  &:after {
    bottom: .625rem;
  }
}

.src {
  background: $col_bgrey;
  z-index: 9;
  padding: 0 0.625rem;
}

.pet, {
  height:  1.875rem;
  width:  1.875rem;

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
  }
}

.pet {
  background: $col_secondary;
  border-radius: 100%;
  right: 1.65rem;
  
  svg {
    fill: $col_white;
    height: 1.05rem;
    width: 1.05rem;
    margin: -0.525rem 0 0 -0.53rem;
  }
}

.img {
  width: 100%;

  &.trans {
    opacity: 0;
  }
}

.head {
  min-height: 4.375rem;
}

.detail {
  padding: 1.25rem 1.625em;
  box-sizing: border-box;

  .lodge & {
    padding: 1.25rem .625em;
  }
}

.titles {
  width: 100%;
  height: 100%;
  float: left;

  .lodge & {
    width: 64%;
  }
}

.foot {
  position: relative;
  min-height: 2.5rem;
}

.price {
  display: flex;
}

.region {
  font-weight: 700;
  display: inline;
  color: $col_bgrey;
  font-size: 1rem;
  margin-bottom: .25rem;
}

.name {
  font-size: .875rem;
  font-weight: 400;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  display: block;
  margin-top: 0.25rem;
}

.side {
  float: right;
  display: flex;
  top: .625rem;
  font-weight: 700;
}

.sleeps,
.beds {
  font-size: .875rem;
  font-weight: 100;
  text-align: right;
  display: flex;
  align-items: baseline;

  svg {
    height: 1.25rem;
    width: 1.25rem;
    position: relative;
    top: 0.313rem;
    left: 0.125rem;
    margin: 0 .313rem 0 0;
  }
}

.beds {
  margin-right: .625rem;
}

.revs {
  display: inline;
  color: $col_primary;
  font-size: .563rem;
  font-weight: 700;
  text-transform: uppercase;
  margin: .625rem 0 0 0;

  strong {
    color: $col_white;
  }
}

.price-line {
  align-self: flex-end;

  .price-con {
    display: flex;
    align-items: baseline;
    flex-direction: row;
  }

  .was {
    font-size: .875rem;
    color: $col_deepgrey;
    position: relative;
    margin-left: 0.313rem;

    &:before {
      content: "was ";
    }

    &:after {
      content: '';
      border-bottom: .125rem solid $col_deepgrey;
      width: 100%;
      position: absolute;
      right: 0;
      top: calc(50% - .0625rem);
    }
  }

  .total {
    font-weight: 700;
    font-size: 1.5rem;
    color: $col_black;
  }
}

.view,
.new {
  position: absolute;
  bottom: 0.625rem;
  font-size: .75rem;
  text-decoration: none;
}

.view {
  color: #221F20;
  display: inline-block;
  text-align: right;
  right: 0;
  font-weight: 600;
  font-size: .75rem;

  &:after {
    content: "\00276F";
    color: #221F20;
    font-weight: 600;
    margin-left: .25rem;
  }

  &:hover {
    color: $col_primary;

    &:after {
      color: $col_primary;
    }
  }
}

@media #{$desktop} {
  .price-line {

    .total {
      font-size: 1.875rem;
    }
  }
}

.card_carousel {
  .imgs img {
    height: 265px;
    object-fit: cover;
  }

  .detail {
    .desc {
      display: none;
    }

    .foot {
      padding-top: 1rem;
      width: 100%;

      .view, .new {
        position: unset;

        @media #{$desktop} {
          position: absolute;
        }
      }
    }
  }
}
</style>